// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/medical-categories.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/medical-categories/medical-categories.js';

mount([g0]);
